/**
 * G2 自定义图形
 * @author zhubincong
 * @date 2020-03-20 14:01:05
 */

import G2 from '@antv/g2'
/**
 * 包含间隔的path，通过cfg.dash传入参数，三个数字分别代表块宽、间隔宽、两端留白
 * @author zhubincong
 * @date 2020-03-20 14:03:43
 */
const dashPath = function() {
  G2.Shape.registerShape('interval', 'dashPath', {
    draw(cfg, container) {
      const dash = [0.03, 0.002, 0.01]
      if (Array.isArray(cfg.dash)) {
        cfg.dash.forEach((n, i) => {
          dash[i] = n
        })
      }
      // 三个数字分别代表块宽、间隔宽、两端留白
      const blockNumber = dash[0] || 0.03
      const blockSliceNumber = dash[1] || 0.002
      const sliceNumber = dash[2] || 0.01
      const points = cfg.points
      let height = points[1].y - points[0].y - sliceNumber
      let path = []
      for (let i = 0; height > 0; ) {
        const startY = i * (blockNumber + blockSliceNumber)
        if (height > blockNumber) {
          path.push(['M', points[0].x, points[0].y + startY])
          path.push(['L', points[1].x, points[0].y + startY + blockNumber])
          path.push(['L', points[2].x, points[0].y + startY + blockNumber])
          path.push(['L', points[3].x, points[3].y + startY])
        } else {
          path.push(['M', points[0].x, points[0].y + startY])
          path.push(['L', points[1].x, points[0].y + startY + height])
          path.push(['L', points[2].x, points[0].y + startY + height])
          path.push(['L', points[3].x, points[3].y + startY])
        }
        height -= blockNumber + blockSliceNumber
        i++
      }
      path.push('Z')
      path = this.parsePath(path)
      return container.addShape('path', {
        attrs: {
          ...cfg.style,
          fill: cfg.color,
          path
        }
      })
    }
  })
}

/**
 * 有间隔的线段，间隔由lineDash设置
 * @author zhubincong
 * @date 2020-03-20 14:30:36
 */
const dashLine = function() {
  G2.Shape.registerShape('interval', 'dashLine', {
    // 绘制渐变线段
    draw(cfg, group) {
      // 自定义最终绘制
      const lineDash = cfg.lineDash || [3, 2]
      const points = this.parsePoints(cfg.points) // 将0-1空间的坐标转换为画布坐标
      return group.addShape('line', {
        attrs: {
          x1: points[0].x,
          y1: points[0].y,
          x2: points[1].x,
          y2: points[1].y,
          lineWidth: 20,
          lineDash,
          stroke: cfg.color
        }
      })
    }
  })
}

/**
 * 头尾有空隙的path
 * @author zhubincong
 * @date 2020-04-01 20:10:39
 */
const slicePath = function(sliceNumber = 0.01) {
  G2.Shape.registerShape('interval', 'slicePath', {
    draw(cfg, container) {
      const points = cfg.points
      let path = []
      path.push(['M', points[0].x, points[0].y])
      path.push(['L', points[1].x, points[1].y - sliceNumber])
      path.push(['L', points[2].x, points[2].y - sliceNumber])
      path.push(['L', points[3].x, points[3].y])
      path.push('Z')
      path = this.parsePath(path)
      return container.addShape('path', {
        attrs: {
          ...cfg.style,
          fill: cfg.color,
          path
        }
      })
    }
  })
}
export { dashPath, dashLine, slicePath }
